import React from "react";
import { DateInput } from "../../components/form-group";
import ErrorMessage from "../../components/text/ErrorMessage";
import { RouteKeys } from "../routes/route-keys";

interface ProjectOverviewTenantsGraphViewProps {
    baseWidth: 250;
    date: Date | undefined;
    errorMessage: string;
    expandedRows: { [key: number]: boolean; };
    filteredTenants: any[] | undefined;
    filteredUnitDetails: any[] | undefined;
    maxWidth: 1000;
    onreset: () => void;
    props: any;
    setDate: React.Dispatch<React.SetStateAction<Date | undefined>>;
    showTenants: () => Promise<void>;
    toggleRow: (rowId: number) => void;
}

export function ProjectOverviewTenantsGraphView({ baseWidth,
    date,
    errorMessage,
    expandedRows,
    filteredTenants,
    filteredUnitDetails,
    maxWidth,
    onreset,
    props,
    setDate,
    showTenants,
    toggleRow }: ProjectOverviewTenantsGraphViewProps) {
    return (
        <div className="pt-4 row pb-3 border-top">
            <div className="col-12 px-0">
                <h2 className="mb-4 pb-1" style={{ fontSize: "21px" }}>
                    Tenants
                </h2>
                <div className="mb-4 col-5">
                    <div className="d-flex">
                        <DateInput
                            // default={new}
                            default={date}
                            placeholder={"Select Date"}
                            onChange={(data) => setDate(data)}
                        />
                        <button
                            type="button"
                            className="btn btn-primary ml-2 w-100"
                            onClick={showTenants}
                        >
                            Show Tenancy View
                        </button>
                        <button
                            type="button"
                            className="btn ml-2"
                            onClick={onreset}
                        >
                            Reset
                        </button>
                    </div>
                    {errorMessage && (
                        <ErrorMessage>{errorMessage}</ErrorMessage>
                    )}
                </div>
            </div>
            {filteredTenants !== undefined ? (
                filteredTenants.length ? (
                    filteredTenants?.map((td: any) => {
                        const largestTotalFloorArea = filteredTenants?.reduce((max, tenant) => {
                            return tenant.totalFloorArea > max ? tenant.totalFloorArea : max;
                        }, 0)
                        return (
                            !!td?.unitDetails?.length && (
                                <div className="col-12 px-0 d-flex mb-2 align-items-center">
                                    <div
                                        className="font-xs py-2"
                                        style={{ width: "24px", minWidth: '24px' }}
                                    >
                                        {td.floorNum === 0 ? "G" : td.floorNum}
                                    </div>

                                    <div className="d-flex flex-1">
                                        {td?.unitDetails?.length ? (
                                            td?.unitDetails?.map((ud: any) => (
                                                <>
                                                    <div className="flex-fill"
                                                        style={{
                                                            width: `${Math.min(
                                                                Math.max(
                                                                    (Number(ud.unitArea) / largestTotalFloorArea) * maxWidth,
                                                                    baseWidth
                                                                ),
                                                                maxWidth
                                                            )}px`
                                                        }}
                                                    >
                                                        <div
                                                            className={`${ud.currentStatus === "Available"
                                                                    ? "bg-t-grey"
                                                                    : "bg-primary"
                                                                } text-white text-center font-sm font-weight-bold py-2 rounded-sm position-relative cursor-pointer h-100`}
                                                            onClick={() => {
                                                                if (ud.companyId) {
                                                                    // history.push(
                                                                    const win = window.open(
                                                                        `${RouteKeys.Company360View}/${ud.companyId || ""
                                                                        }`,
                                                                        "_blank"
                                                                    );
                                                                    if (win) {
                                                                        win.focus();
                                                                    }
                                                                    //   `${RouteKeys.Company360View}/${
                                                                    //     ud.companyId || ""
                                                                    //   }`
                                                                    // );
                                                                }
                                                            }}
                                                        >
                                                            {ud.currentStatus === "Available"
                                                                ? "Available Unit"
                                                                : ud.currentStatus === "Leased"
                                                                    ? "Leased Unit"
                                                                    : ud.tenantsName}
                                                            {ud.currentStatus === "Available" && (
                                                                <i
                                                                    className={`${expandedRows[ud?.unitName]
                                                                            ? "icon-chevron-down"
                                                                            : "icon-chevron-up"
                                                                        } position-absolute right-0 align-y-center px-2 mx-1`}
                                                                    onClick={() =>
                                                                        toggleRow(ud?.unitName)
                                                                    }
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    {expandedRows[ud?.unitName] && (
                                                        <div
                                                            className="bg-gray-100 py-3 px-4 mt-1 w-100 order-1"
                                                            style={{ marginLeft: "24px" }}
                                                        >
                                                            <div className="row align-items-center">
                                                                <div className="col-md-9 col-12">
                                                                    <div className="row">
                                                                        <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                            <div className="text-gray-500">
                                                                                Type
                                                                            </div>
                                                                            <div>
                                                                                {ud?.propertyTypeName ||
                                                                                    props.project?.type}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                            <div className="text-gray-500">
                                                                                Area
                                                                            </div>
                                                                            <div>
                                                                                {ud?.unitArea
                                                                                    ? `${ud?.unitArea} Sq. Ft`
                                                                                    : ""}{" "}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                            <div className="text-gray-500">
                                                                                Floor Offered
                                                                            </div>
                                                                            <div>
                                                                                {" "}
                                                                                {td?.floorNum === 0
                                                                                    ? "G"
                                                                                    : td?.floorNum}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                            <div className="text-gray-500">
                                                                                Status
                                                                            </div>
                                                                            <div>
                                                                                {ud?.propertyCurrentStatus
                                                                                    ? ud?.propertyCurrentStatus
                                                                                    : "Ready to move"}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                            <div className="text-gray-500">
                                                                                Type of Facility
                                                                            </div>
                                                                            <div>
                                                                                {ud?.interior
                                                                                    ? ud?.interior
                                                                                    : "Pre Furnished"}
                                                                            </div>
                                                                        </div>
                                                                        {filteredUnitDetails?.find(
                                                                            (x) =>
                                                                                x.propertyID === ud.propertyID
                                                                        )?.propertyId && (
                                                                                <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            props.onView?.(
                                                                                                filteredUnitDetails?.find(
                                                                                                    (x) =>
                                                                                                        x.propertyID ===
                                                                                                        ud.propertyID
                                                                                                )?.propertyId!
                                                                                            )
                                                                                        }
                                                                                        className="btn btn-primary px-1 font-sm font-weight-semibold py-1 mt-1 rounded"
                                                                                    >
                                                                                        View Details
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ))
                                        ) : (
                                            <div>No Unit Details Found</div>
                                        )}
                                    </div>
                                </div>
                            )
                        );
                    })
                ) : (
                    <span className="mt-2 mb-2 ml-3">No results Found</span>
                )
            ) : (
                props.project?.tenantDetails?.map((td: any) => {
                    const largestTotalFloorArea = props.project?.tenantDetails?.reduce((max:any, tenant:any) => {
                        return tenant.totalFloorArea > max ? tenant.totalFloorArea : max;
                    }, 0)
                    return (
                        !!td?.unitDetails?.length && (
                            <div className="col-12 px-0 d-flex mb-2 align-items-center" >
                                <div
                                    className="font-xs py-2"
                                    style={{ width: "24px", minWidth: "24px" }}
                                >
                                    {td.floorNum === 0 ? "G" : td.floorNum}
                                </div>

                                <div className="d-flex flex-1">
                                    {td?.unitDetails?.length ? (
                                        td?.unitDetails?.map((ud: any) => (
                                            <>
                                                <div
                                                    style={{
                                                        width: `${Math.min(
                                                            Math.max(
                                                                (Number(ud.unitArea) / largestTotalFloorArea) * maxWidth,
                                                                baseWidth
                                                            ),
                                                            maxWidth
                                                        )}px`
                                                    }}
                                                >
                                                    <div
                                                        className={`${ud.currentStatus === "Available"
                                                                ? "bg-t-grey"
                                                                : "bg-primary"
                                                            } text-white text-center font-sm font-weight-bold py-2 rounded-sm position-relative cursor-pointer h-100`}
                                                        onClick={() => {
                                                            if (ud.companyId) {
                                                                // history.push(
                                                                const win = window.open(
                                                                    `${RouteKeys.Company360View}/${ud.companyId || ""
                                                                    }`,
                                                                    "_blank"
                                                                );
                                                                if (win) {
                                                                    win.focus();
                                                                }
                                                                //   `${RouteKeys.Company360View}/${
                                                                //     ud.companyId || ""
                                                                //   }`
                                                                // );
                                                            }
                                                        }}
                                                    >
                                                        {ud.currentStatus === "Available"
                                                            ? "Available Unit"
                                                            : ud.currentStatus === "Leased"
                                                                ? "Leased Unit"
                                                                : ud.tenantsName}
                                                        {ud.currentStatus === "Available" && (
                                                            <i
                                                                className={`${expandedRows[ud?.unitName]
                                                                        ? "icon-chevron-down"
                                                                        : "icon-chevron-up"
                                                                    } position-absolute right-0 align-y-center px-2 mx-1`}
                                                                onClick={() => toggleRow(ud?.unitName)}
                                                            />
                                                        )}
                                                    </div>
                                                </div>

                                                {expandedRows[ud?.unitName] && (
                                                    <div
                                                        className="bg-gray-100 py-3 px-4 mt-1 w-100 order-1"
                                                        style={{ marginLeft: "24px" }}
                                                    >
                                                        <div className="row align-items-center">
                                                            <div className="col-md-9 col-12">
                                                                <div className="row">
                                                                    <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                        <div className="text-gray-500">
                                                                            Type
                                                                        </div>
                                                                        <div>
                                                                            {ud?.propertyTypeName ||
                                                                                props.project?.type}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                        <div className="text-gray-500">
                                                                            Area
                                                                        </div>
                                                                        <div>
                                                                            {ud?.unitArea
                                                                                ? `${ud?.unitArea} Sq. Ft`
                                                                                : ""}{" "}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                        <div className="text-gray-500">
                                                                            Floor Offered
                                                                        </div>
                                                                        <div>
                                                                            {" "}
                                                                            {td?.floorNum === 0
                                                                                ? "G"
                                                                                : td?.floorNum}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                        <div className="text-gray-500">
                                                                            Status
                                                                        </div>
                                                                        <div>
                                                                            {ud?.propertyCurrentStatus
                                                                                ? ud?.propertyCurrentStatus
                                                                                : "Ready to move"}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                        <div className="text-gray-500">
                                                                            Type of Facility
                                                                        </div>
                                                                        <div>
                                                                            {ud?.interior
                                                                                ? ud?.interior
                                                                                : "Pre Furnished"}
                                                                        </div>
                                                                    </div>
                                                                    {props.project?.unitDetails?.find(
                                                                        (x:any) =>
                                                                            x.propertyID === ud.propertyID
                                                                    )?.propertyId && (
                                                                            <div className="col-md-2 col-sm-3 col-4 font-sm mb-2 pt-1">
                                                                                <button
                                                                                    onClick={() =>
                                                                                        props.onView?.(
                                                                                            props.project?.unitDetails?.find(
                                                                                                (x:any) =>
                                                                                                    x.propertyID ===
                                                                                                    ud.propertyID
                                                                                            )?.propertyId!
                                                                                        )
                                                                                    }
                                                                                    className="btn btn-primary px-1 font-sm font-weight-semibold py-1 mt-1 rounded"
                                                                                >
                                                                                    View Details
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        ))
                                    ) : (
                                        <div>No Unit Details Found</div>
                                    )}
                                </div>
                            </div>
                        )
                    );
                })
            )}
        </div>
    );
}
